import React from "react";
import { Box } from "@mui/material";
import { SectionHeader } from "@/components/common/section-header";
import { TravelStyleSection as TravelStyleSectionType } from "@/types/dto/deals-page/deals-page-types";
import {
  isDarkLandingPageBackground,
  resolveLandingPageSectionBackgroundColor
} from "@/utils/landing-page-background";
import TravelStyleCard from "./travel-style-card";

export interface TravelStyleSectionProps {
  data: TravelStyleSectionType;
}

const TravelStyleSection: React.FC<TravelStyleSectionProps> = ({ data }) => {
  if (!data || !data.cards || data.cards.length === 0) {
    return null;
  }

  const { basicInfo, cards } = data;
  const resolvedBackgroundColor = resolveLandingPageSectionBackgroundColor(data.backgroundColor, "background.default");
  const isDarkBackground = isDarkLandingPageBackground(data.backgroundColor);

  return (
    <Box
      component="section"
      data-testid="travel-style-section"
      data-track="visibility"
      data-module-name="Deals by Travel Style Section"
      data-parent-container-type="grid"
      data-ranking-algorithm="manual"
      data-module-ranking-position="5"
      sx={{
        padding: "40px 24px",
        "@media (min-width: 1020px)": {
          padding: "40px 100px"
        },
        backgroundColor: resolvedBackgroundColor
      }}
    >
      <SectionHeader
        headerText={basicInfo.headerText}
        copyText={basicInfo.copyText}
        headerTestId="travel-style-section-header"
        copyTestId="travel-style-section-subheader"
        headerSx={{
          textAlign: "center",
          textTransform: "none !important",
          color: isDarkBackground ? "primary.contrastText" : "text.primary"
        }}
        copySx={{ textAlign: "center", color: isDarkBackground ? "primary.contrastText" : "text.primary" }}
        sx={{ mb: "0.6rem", gap: "0.6rem" }}
      />

      <Box
        sx={{
          maxWidth: "1240px",
          margin: "0 auto",
          width: "100%",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "20px"
        }}
      >
        {cards.map((card, index) => (
          <Box
            key={card.id}
            sx={{
              width: { xs: "100%", sm: "400px" },
              maxWidth: "400px",
              flex: { xs: "1 1 100%", sm: "0 0 400px" },
              display: "flex",
              justifyContent: "center"
            }}
          >
            <TravelStyleCard card={card} cardIndex={index} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default TravelStyleSection;
